import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import FormSelect from '../inputFields/FormSelect'
import MaskedInput from '../inputFields/MaskedInput'
import FormInput from '../inputFields/FormInput'
import { FormRow, FlexColumn } from '../styles/Containers'
import { Subheading } from '../styles/Text'
import pirTerminology from '../../util/pirTerminology'

function StrataForm({ disabled = false }) {
  const { getValues } = useFormContext()
  const [defaultRole, setDefaultRole] = useState()

  useEffect(() => {
    setDefaultRole(getValues('strataInformation.role') || '')
  }, [])

  return (
    <FlexColumn>
      <FlexColumn gap="10px">
        <Subheading>{pirTerminology.getAssociationLabel('Details')}</Subheading>
        <FormRow>
          <FormInput required={true} id="strataInformation.strataNumber" label={pirTerminology.getAssociationLabel('Number')} disabled={disabled} />
        </FormRow>
      </FlexColumn>
      <FlexColumn gap="10px">
        <Subheading>Contact Information</Subheading>
        <FormRow>
          {defaultRole !== undefined && (
            <FormSelect
              required={true}
              id="strataInformation.role"
              label="Role"
              options={['President', 'Vice President', 'Property Manager', 'Secretary', pirTerminology.getBoardMemberRole()]}
              disabled={disabled}
              defaultValue={defaultRole}
            />
          )}
          <FormInput required={true} id="strataInformation.firstName" label="First Name" disabled={disabled} />
          <FormInput required={true} id="strataInformation.lastName" label="Last Name" disabled={disabled} />
          <FormInput required={true} id="strataInformation.address" label="Address" disabled={disabled} />
          <MaskedInput required={true} id="strataInformation.phone" label="Phone" format="(###) ###-####" disabled={disabled} />
          <FormInput
            required={true}
            id="strataInformation.email"
            label="Email"
            disabled={disabled}
            tooltip="A digital signature request will be sent to this email to authorize this request."
          />
          <FormInput required={true} id="strataInformation.confirmEmail" label="Confirm Email" disabled={disabled} />
          <FormInput id="strataInformation.additionalName" label="Additional Name" disabled={disabled} />
        </FormRow>
      </FlexColumn>
    </FlexColumn>
  )
}

StrataForm.propTypes = {
  disabled: PropTypes.bool
}

export default StrataForm
